<template>
  <v-select
      v-model="item"
      dir="rtl"
      :multiple="multiple"
      label="Title"
      :reduce="x => x.Id"
      :loading="loading"
      :selectable="x => unselectable.includes(x.Id) === false || x === val"
      @open="onOpen"
      :clearable="clearable"
      :options="activityPackageId.length ? items.filter(x => activityPackageId.includes(x.ActivityPackageId)) : items"
  >
    <span
        slot="no-options"
        @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
            v-if="loading"
            class="m-0"
            small
            variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'ZActivityPackageCourse',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    activityPackageId: {
      type:  Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
    activityPackageId(v, old) {
      if (v.toString() !== old.toString()) {
        if(this.multiple) {
          this.item = []
         }else{
      this.item = null
        }
      }
    }
  },
  computed: {
    ...mapState('zirehState', { items: state => state.activityPackageCourseSelect }),
    ...mapState('zirehState', { flag: state => state.activityPackageCourseSelectFlag }),
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setActivityPackageCourseSelectFlag', true)
        this.loading = true
        this.$http.post(
            this.$api.activitypackagecourse.getall, {},
        )
            .then(res => {
              this.$store.commit('zirehState/setActivityPackageCourseSelect', res.data)
              this.loading = false
            })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
